import { EmbarcacoesTabelaView } from "./view-embarcacoes-tabela";
import type { EmbarcacoesTabelaProps } from "./types-embarcacoes-tabela";

/** Liga a tabela da listagem: sem lógica própria, todas as propriedades vêm do ViewModel da tela. */
export function EmbarcacoesTabela(props: EmbarcacoesTabelaProps) {
  return <EmbarcacoesTabelaView {...props} />;
}

export type * from "./types-embarcacoes-tabela";
